/**
 * Serializes a JSON-LD node for inline `<script>` content, escaping `<` so user
 * text such as a review cannot close the tag.
 *
 * @param node - Structured-data object.
 * @returns Script-safe JSON.
 */
export function serializeJsonLd(node) {
    return JSON.stringify(node).replace(/</g, "\\u003c");
}
//# sourceMappingURL=jsonLd.js.map